import { StyleSheet } from "react-native";

import type { UiTheme } from "../theme";

// Styles for the Home hero (HomeHero). Reduced-vision first: large session
// title, a 52pt primary CTA, generous spacing. Lifted from apps/mobile with
// the Home hero surface; consumers call makeHeroStyles(theme) unchanged.
// NOTE: `card` is content-only (padding + gap) — the box chrome (border,
// radius, margins, surface) is drawn ONCE by HomeView's hero wrapper
// (makeHomeBoxStyle), which boxes BOTH hero variants; drawing it here too
// would double-box this one (HR-9).
export function makeHeroStyles(theme: UiTheme) {
  const { palette: p, spacing: s, radius: r, typography: t } = theme;
  return StyleSheet.create({
    card: {
      padding: s.s5,
      gap: s.s3,
    },
    eyebrow: {
      color: p.ink3,
      fontSize: t.sizes.sm,
      fontWeight: "700",
      letterSpacing: 1,
    },
    sessionName: {
      color: p.ink,
      fontSize: t.sizes.xl,
      fontWeight: "700",
      letterSpacing: -0.4,
    },
    meta: {
      color: p.ink2,
      fontSize: t.sizes.base,
      fontWeight: "600",
    },
    // The session preview lists the day's exercises — meaningful content
    // Antenore reads, not a decorative caption → AA-floor ink2 (the eyebrow
    // kicker stays ink3 as a decorative label).
    preview: {
      color: p.ink2,
      fontSize: t.sizes.sm,
      lineHeight: t.sizes.sm * 1.4,
    },
    blankTitle: {
      color: p.ink,
      fontSize: t.sizes.lg,
      fontWeight: "700",
      letterSpacing: -0.4,
    },
    blankBody: {
      color: p.ink2,
      fontSize: t.sizes.base,
      lineHeight: t.sizes.base * 1.4,
    },
    cta: {
      minHeight: 40,
      marginTop: s.s2,
      paddingVertical: s.s4,
      paddingHorizontal: s.s5,
      borderRadius: r.r3,
      backgroundColor: p.brand500,
      alignItems: "center",
      justifyContent: "center",
    },
    ctaPressed: { opacity: 0.7 },
    ctaText: {
      color: p.inkOnBrand,
      fontSize: t.sizes.md,
      fontWeight: "700",
    },
    linkBtn: {
      minHeight: 44,
      alignItems: "center",
      justifyContent: "center",
    },
    linkBtnPressed: { opacity: 0.6 },
    linkText: {
      color: p.brand500,
      fontSize: t.sizes.base,
      fontWeight: "600",
    },
  });
}
